<div id="home">
  <div id="hero-section">
    <h1 class="hero-title">
      <img
        src="a/images/devfestmn.svg"
        width="400"
        height="350"
        fetchpriority="high"
        style="width: 40%; max-width: 400px; min-width: 250px; height: auto"
        alt="DevFestMN 2026"
      />
      <span class="visually-hidden">: </span>
      <span class="hero-subtitle">Twin Cities Developer Conference</span>
    </h1>
    <div>
      <div class="event-hero-info">
        <span class="icon-text-link">
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
              fill="#000000"
              d="M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z"
            ></path>
          </svg>
          <span>{{ environment.eventDateDisplay }}</span>
        </span>
        <a [href]="environment.venueMapUrl" target="_blank" class="icon-text-link">
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
              fill="#000000"
              d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z"
            ></path>
          </svg>
          <span>{{ environment.venueName }}</span>
        </a>
      </div>
    </div>

    <!-- Call to Action Buttons -->
    @if (cfp() === 'open' || environment.showRegister) {
      <div class="cta-block hero-cta">
        @if (cfp() === 'open') {
          <a routerLink="/speaker-cfp" class="cta all-caps">Submit a Session</a>
        }
        @if (environment.showRegister) {
          <a href="#tickets" class="cta all-caps">Get Tickets</a>
        }
      </div>
    }
    @if (cfp() === 'open') {
      <p class="hero-deadline">
        Call for speakers closes {{ environment.cfpCloses | date: 'MMMM d' }}
        @if (cfpCountdown(); as countdown) {
          <strong>· {{ countdown }}</strong>
        }
      </p>
    }
  </div>
  @if (dayOf()) {
    <section>
      <div>
        <h2>Important Details for Attendees</h2>
        <div class="callout"><a [href]="environment.surveyLink">Survey</a></div>
        <div class="cta-block">
          <a [href]="environment.surveyLink" class="cta all-caps"
            >Please fill out the participant survey here</a
          >
        </div>
        <div class="callout">Getting There</div>
        <p>
          See <a href="#venue">the venue map, parking, and directions to the rooms</a> below. Follow
          the DevFestMN signs to the registration table on the ground floor.
        </p>
        <div class="callout">Wi-Fi</div>
        <p>Guest Wi-Fi details will be posted at the registration table.</p>
        <div class="callout">Lunch</div>
        <p>We will have a catered lunch break</p>
        <div class="callout">Event Hashtag</div>
        <p>
          Join the conversation on Social Media using
          <strong>#DevFestMN</strong>
        </p>
      </div>
    </section>
  }
  <section id="what-to-expect">
    <div>
      <h2>What to Expect</h2>
      <p>
        DevFestMN is one of the best developer conferences in the Midwest. This year the event
        features a single day of content and connections. This year's 2026 DevFestMN event will
        cover the latest and greatest insights about AI and software engineering, with a smattering
        of Google's platforms covering Gemini, Cloud, Android, and web development.
      </p>
      <div class="split-column">
        <img
          src="/a/images/background.webp"
          width="800"
          height="533"
          loading="lazy"
          alt="downtown view of Minneapolis"
        />
        <div>
          <p>
            DevFestMN has been running since 2013. Over the years we've been thankful for the
            amazing community that has grown around the event. We've been able to invite speakers
            and attendees from around the world. DevFest has a diverse group of participants that
            spans from students to industry professionals. We've featured over 50 speakers.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section>
    <div>
      <h2>About Us</h2>

      <div class="callout">
        1 Day, 2 Tracks. <br />
        World renowned speakers.
        <!-- <br/>600 Attendees -->
      </div>

      <p>
        <strong>Google Developer Group DevFests</strong> are the largest Google related events in
        the world! Each DevFest is carefully crafted for you by your local GDG community to bring in
        awesome speakers, great topics, and lots of fun! While no two events will be exactly alike,
        each GDG DevFest will, at its core, be powered by a shared belief that when developers come
        together to exchange ideas, amazing things can happen!
      </p>
    </div>
  </section>

  @if (cfp() === 'open') {
    <section>
      <div>
        <h2>Speakers Welcome!</h2>
        <p>
          Our call for speakers is open until
          <strong>{{ environment.cfpCloses | date: 'MMMM d' }}</strong
          >. Please submit your session via the link below. We can't wait to hear from you!
        </p>
        <p>
          <a routerLink="/speaker-cfp" class="cta all-caps" style="display: inline"
            >Speak at DevFestMN</a
          >
        </p>
      </div>
    </section>
  }
  @if (speakers().length) {
    <section>
      <div>
        <h2>Speakers</h2>
        @if (featuredSpeakers().length) {
          <div class="featured-speakers">
            @for (speaker of featuredSpeakers(); track speaker.$key) {
              <a [routerLink]="['/', 'speakers', speaker.$key, slugify(speaker.name)]">
                @if (speaker.imageUrl) {
                  <img
                    [src]="speaker.imageUrl"
                    [alt]="'Photo of ' + speaker.name"
                    width="96"
                    height="96"
                    loading="lazy"
                  />
                } @else {
                  <span class="no-photo"></span>
                }
                <strong>{{ speaker.name }}</strong>
                @if (speaker.company) {
                  <span>{{ speaker.company }}</span>
                }
              </a>
            }
          </div>
        }
        <p>
          Check out all the speakers we've announced so far on the
          <a routerLink="/speakers">Speakers</a> page.
        </p>
      </div>
    </section>
  }

  <section id="home-section-sponsors" class="section-background">
    <div>
      <h2>{{ environment.year }} Sponsors</h2>
      <p>This event would not be possible without our awesome sponsors.</p>
      @for (sponsorGroup of environment.sponsors; track sponsorGroup.type) {
        <div>
          <h3>{{ sponsorGroup.type }} Sponsors</h3>
          @for (sponsor of sponsorGroup.list; track sponsor.name) {
            <div class="sponsor-bar">
              <a href="{{ sponsor.url }}">
                <img src="{{ sponsor.logo }}" loading="lazy" alt="{{ sponsor.name }} Logo" />
              </a>
            </div>
          }
        </div>
      }
      @if (environment.showSponsor) {
        <p>Sponsorships are still available! <a routerLink="/sponsors">Inquire Now</a></p>
      }

      <!--
      <h3>Nougat Community Sponsors</h3>
      <div class="sponsor-bar">
        <img src="/a/images/sponsors/buzzfeed.png" alt="BuzzFeed Logo" />
      </div>
      <h3>General Sponsors</h3>
      <div class="sponsor-bar">
        <img src="/a/images/sponsors/google.svg" alt="Google Logo" />
      </div>
      <h3>Supporters</h3>
      <div class="sponsor-bar">
        <img src="/a/images/sponsors/jetbrains.svg" alt="Google Logo" />
      </div>
      -->
    </div>
  </section>

  <section id="join">
    <div>
      <h2>Join Us</h2>
      <h3>Let us know how you want to get involved!</h3>
      <div class="cta-block">
        @if (environment.showSponsor) {
          <a routerLink="/sponsors" class="cta all-caps">Sponsor</a>
        }
        @if (cfp() === 'open') {
          <a routerLink="/speaker-cfp" class="cta all-caps">Speak</a>
        }
        @if (environment.showRegister) {
          <a routerLink="/tickets" class="cta all-caps">Register</a>
        }
      </div>
    </div>
  </section>

  <!-- <section id="newsletter">
    <div>
      <h2>Stay Updated</h2>
      <p>Join our newsletter so you can get our latest updates.</p>
      <form>
        <div class="input-with-button">
          <input type="email" name="email" placeholder="Your email">
          <button>Join</button>
        </div>
      </form>
    </div>
  </section> -->

  <section id="faq">
    <div>
      <h2>Frequently Asked Questions</h2>
      <div class="split-column faq-table">
        <ul>
          <li>
            <button
              type="button"
              (click)="setFaqSelection(1)"
              [attr.aria-expanded]="faqSelection() === 1"
              aria-controls="faq-answer"
            >
              How can I speak at DevFestMN?
            </button>
          </li>
          <li>
            <button
              type="button"
              (click)="setFaqSelection(2)"
              [attr.aria-expanded]="faqSelection() === 2"
              aria-controls="faq-answer"
            >
              How do I become a DevFestMN sponsor?
            </button>
          </li>
          <li>
            <button
              type="button"
              (click)="setFaqSelection(3)"
              [attr.aria-expanded]="faqSelection() === 3"
              aria-controls="faq-answer"
            >
              How can I volunteer at DevFestMN events?
            </button>
          </li>
          <li>
            <button
              type="button"
              (click)="setFaqSelection(4)"
              [attr.aria-expanded]="faqSelection() === 4"
              aria-controls="faq-answer"
            >
              What do I wear?
            </button>
          </li>
        </ul>

        @if (faqSelection() === 1) {
          <div id="faq-answer" aria-live="polite">
            <p>
              @if (cfp() === 'open') {
                The CFP is open until {{ environment.cfpCloses | date: 'MMMM d' }}!
                <a routerLink="/speaker-cfp">Submit a session</a>.
              } @else if (cfp() === 'closed') {
                The call for speakers is now closed. Please try again next year.
              } @else {
                We haven't announced the CFP yet, stay tuned in the coming weeks!
              }
            </p>
          </div>
        }
        @if (faqSelection() === 2) {
          <div id="faq-answer" aria-live="polite">
            <p>
              We offer a variety of sponsorship levels and love to work with companies to find the
              right arrangement.
            </p>
            <p>
              If you're interested in sponsoring check out our
              <a routerLink="/sponsors">sponsor guide</a>.
            </p>
          </div>
        }
        @if (faqSelection() === 3) {
          <div id="faq-answer" aria-live="polite">
            <p>
              @if (environment.showVolunteer) {
                Sign up to volunteer through <a href="{{ environment.showVolunteer }}">Sign Up</a>.
                We're accepting volunteers to help with Registration, Setup, Cleanup, and it's
                always great to have welcoming faces. Volunteers get a free ticket!
              } @else {
                We'll be announcing how to sign up as a volunteer soon.
              }
            </p>
          </div>
        }
        @if (faqSelection() === 4) {
          <div id="faq-answer" aria-live="polite">
            <p>
              We like to keep things casual at DevFestMN but wear whatever makes you feel
              comfortable! Most people wear jeans and a t-shirt.
            </p>
          </div>
        }
      </div>
    </div>
  </section>

  @if (environment.showRegister) {
    <section id="tickets">
      <div>
        <h2>Tickets</h2>
        @defer (on viewport) {
          <app-ticket-embed></app-ticket-embed>
        } @placeholder {
          <p>Loading tickets...</p>
        }
      </div>
    </section>
  }

  <section id="venue">
    <div>
      <h2>Getting There</h2>
      <app-venue-info></app-venue-info>
    </div>
  </section>
</div>
